import React, { useState } from 'react'
import { LoginForm } from '../../components/loginForm'
import { useAuth } from '../../context/auth'
// import { Link } from 'react-router-dom'


export const Login = ({pageRef=''}: {pageRef?: string}) => {
  const [userName, setUserName] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const { Login, signed,   } = useAuth()

  if (pageRef !== '' && signed === false) {
    localStorage.setItem('referrer', pageRef || '')
  }

  const handleLogin = (): void => {
    Login({ userName, password })
  }

  return (
    <div className='mb-5 mt-5'>
      <h2 className='fw-bold mb-2 text-uppercase form-title display-line-break'>Pharmacy<br/>Innovations</h2>
      <p className='form-sub-title text-center'>Please enter your login and password!</p>
      <div className='my-5 mx-4'>
        <LoginForm
          setUserName={setUserName}
          setPassword={setPassword}
          handleLogin={handleLogin}
          btnTitle='Login'
        />

        {/* <div className='mt-3'>
          <p className='mb-0 text-center form-footer-text'>
            Don't have an account?{' '}
            <Link to='/signupNotForAllHi' className='text-primary fw-bold'>
              Sign up
            </Link>
          </p>
        </div> */}
      </div>
    </div>
  )
}
